module.exports = __webpack_public_path__ + "img/germae.8bfd99f4.jpeg";